var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlindsSemiClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H39V42H9V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8V39H12V8H9V39V42H12H36H39V39V8H36Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H44V21H4V18ZM4 25H44V22H4V25ZM4 13H44V10H4V13ZM4 6V9H44V6H4ZM4 17H44V14H4V17Z",
    fill: "#EE8003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 27C43 27.6 42.6 28 42 28C41.4 28 41 27.6 41 27C41 26.4 41.4 26 42 26C42.6 26 43 26.4 43 27ZM42 29C41.4 29 41 29.4 41 30C41 30.6 41.4 31 42 31C42.6 31 43 30.6 43 30C43 29.4 42.6 29 42 29ZM42 32C41.4 32 41 32.4 41 33C41 33.6 41.4 34 42 34C42.6 34 43 33.6 43 33C43 32.4 42.6 32 42 32ZM42 39C43.1 39 44 38.1 44 37C44 35.9 43.1 35 42 35C40.9 35 40 35.9 40 37C40 38.1 40.9 39 42 39Z",
    fill: "#9FA8DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlindsSemiClosed);
export default __webpack_public_path__ + "static/media/blinds-semi-closed.7cfbd738f3f6ccecd64fbca33358c9db.svg";
export { ForwardRef as ReactComponent };